import React, { Fragment } from 'react';
import { Button, Card, CardBody, Col, Row, Label, Input, FormGroup, FormFeedback, Table } from 'reactstrap';
import Tooltip from '@material-ui/core/Tooltip';
import moment from 'moment';
import { formatNumber } from '../../Utils/Money';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel, faFilePdf, faSave } from "@fortawesome/free-solid-svg-icons";
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import detailsPaymentPdf from './PdfDetailPayment';
import LocalAtmIcon from '@material-ui/icons/LocalAtm';


const no_op = () => { };
const ShowPayment = ({ payment, invoiceInfo, incomeToPay, invoiceToEdit = null, setShowPaymentPDF, incomeToPayWhatsLeft = no_op, totalInvoice }) => {
    const profile = JSON.parse(sessionStorage.getItem('clinica'));
    const emitionDate = invoiceInfo !== null && invoiceInfo !== undefined && typeof invoiceInfo !== '[]' && invoiceInfo.length ? moment(invoiceInfo[0].fecha_emision).format('DD-MM-YYYY') : '';
    //const totalInvoice = invoiceInfo !== null && invoiceInfo !== undefined && typeof invoiceInfo !== '[]' && invoiceInfo.length ? invoiceInfo[0].total : '';
    const urlLogo = sessionStorage.getItem('logoURL');

    const exportPaymentToExcel = () => {
        const data = {
            paymentInfo: payment,
            invoiceInfo: invoiceInfo,
            incomeToPay: incomeToPay,
            totalInvoice: totalInvoice,
            profile: profile,
            urlLogo: urlLogo
        }
        setShowPaymentPDF(true);
        detailsPaymentPdf(data);
    }

    const onToggleToEdit = () => {
        invoiceToEdit(payment, true);
    }

    const onTogglePayWhatIsLeft = () => {
        incomeToPayWhatsLeft(invoiceInfo[0]);
    }

    return (
        <Fragment>
            <div className='card-payments-display'>
                <Row>
                    <div className='card-top-name'>
                        <h5><b>Pago No.</b>{payment.id_pago} - <b>FAC.</b>{payment.num_fac_ter}</h5>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: '1em' }}>
                        <div style={{ padding: '1em 0em' }}>
                            <h5><b>{profile.nombre}</b></h5>
                            <p>{profile.direccion.direccion}</p>
                            <p style={{ margin: 0 }}><b>NIT: </b>{profile.nit}</p>
                        </div>
                        {invoiceInfo !== null && invoiceInfo !== undefined && typeof invoiceInfo !== '[]' && invoiceInfo.length ?
                            <div style={{ padding: '1em 0em' }}>
                                <h5><b>{invoiceInfo[0].nombre_facturado}</b></h5>
                                <p>{invoiceInfo[0].num_documento}</p>
                            </div>
                            : null}
                    </div>
                </Row>
                <Row>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                        <div>
                            <h5><b>Recibo de Pago</b></h5>
                        </div>
                    </div>
                    <hr style={{ color: '#55e5bb' }}></hr>
                    <Col md={6}>
                        <p>Fecha de Pago: {moment(payment.fecha_pago).format('DD-MM-YYYY')}</p>
                        <p>Modo de Pago: {payment.forma_pago}</p>
                        <hr style={{ color: '#55e5bb' }}></hr>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', backgroundColor: '#55e5bb', padding: '1em 0em' }}>
                            <p><b>Importe total:</b></p>
                            <p style={{ margin: 0 }}><b>${formatNumber(payment.importe)}</b></p>
                        </div>
                    </Col>
                    <Col md={6}>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'flex-end', height: '100%' }}>
                            {invoiceToEdit &&
                                <div>
                                    <Tooltip title="Editar">
                                        <Button
                                            style={{ margin: '.25em .25em', color: "#FF9E00" }}
                                            variant="contained"
                                            size='sm'
                                            onClick={() => {
                                                onToggleToEdit();
                                            }}
                                        >
                                            <EditOutlinedIcon style={{ fontSize: '20px' }} />
                                        </Button>
                                    </Tooltip>
                                </div>
                            }
                            {
                                incomeToPayWhatsLeft !== '() => {}' ?
                                    incomeToPay > 0 ?
                                        <div>
                                            <Tooltip title="Pagar el resto del importe">
                                                <Button
                                                    style={{ margin: '.25em .25em', color: "#0C98E8" }}
                                                    variant="contained"
                                                    size='sm'
                                                    onClick={() => {
                                                        onTogglePayWhatIsLeft();
                                                    }}
                                                >
                                                    <LocalAtmIcon style={{ fontSize: '20px' }} />
                                                </Button>
                                            </Tooltip>
                                        </div>
                                        : null
                                    : null
                            }
                            <div>
                                <Tooltip title="Exportar a PDF">
                                    <Button
                                        style={{ margin: '.25em .25em' }}
                                        variant="contained"
                                        color="success"
                                        size='sm'
                                        onClick={() => {
                                            exportPaymentToExcel();
                                        }}
                                    >
                                        <FontAwesomeIcon style={{ fontSize: '20px' }} icon={faFilePdf} />
                                    </Button>
                                </Tooltip>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <h6 style={{ marginTop: '1em' }}><b>Recibo de Pago</b></h6>
                    <Col>
                        <Table
                            className="table--bordered"
                            responsive
                            size='sm'
                            bordered
                        >
                            <thead>
                                <tr>
                                    <th> Nro. de Factura </th>
                                    <th> Fecha de la Factura</th>
                                    <th> Total de la Factura</th>
                                    <th> Importe del Pago</th>
                                    <th> Importe a pagar</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th scope="row">{payment.num_fac_ter}</th>
                                    <td>{emitionDate}</td>
                                    <td>${formatNumber(totalInvoice)}</td>
                                    <td>${formatNumber(payment.importe)}</td>
                                    <td>${formatNumber(incomeToPay)}</td>
                                </tr>
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </div>

        </Fragment>
    )
}

export default ShowPayment